import type { RootState } from "../store"

export const selectedPracticeRoleSelector = (state: RootState) =>
    state.userDetails.selectedPracticeRole
